import React, { useState } from 'react';
import { API_BASE } from '../config';

export default function CombatSettings({ onClose, inline }) {
  const [settings, setSettings] = useState({
    turnTimer: '60',
    autoAdvance: true,
    enemyAI: 'random',
    friendlyFire: false,
    deathSaves: true,
    overkillCarry: false,
    critMultiplier: '2x',
    initiativeStyle: 'standard',
    zoneCombat: localStorage.getItem('zone_combat') !== 'false',
    combatSorting: localStorage.getItem('combat_sorting') !== 'false',
  });

  const update = (key, value) => setSettings(prev => ({ ...prev, [key]: value }));

  const handleSave = () => {
    localStorage.setItem('zone_combat', settings.zoneCombat);
    localStorage.setItem('combat_sorting', settings.combatSorting);
    const session = localStorage.getItem('session');
    if (session) {
      try {
        const part = session.split('.')[1];
        const padded = part + '='.repeat((4 - part.length % 4) % 4);
        const payload = JSON.parse(atob(padded.replace(/-/g,'+').replace(/_/g,'/')));
        fetch(`${API_BASE}/state/${payload.guild_id}`, {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + session, 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'set_config', zone_combat: settings.zoneCombat, combat_sorting: settings.combatSorting })
        });
      } catch {}
    }
    onClose();
  };

  if (inline) return (
    <div className="settings-inline">
      <div className="modal-body">
        <div className="setting-row">
          <label>Turn Timer</label>
          <select value={settings.turnTimer} onChange={e => update('turnTimer', e.target.value)}>
            <option value="30">30 seconds</option>
            <option value="60">60 seconds</option>
            <option value="90">90 seconds</option>
            <option value="unlimited">Unlimited</option>
          </select>
        </div>
        <div className="setting-row"><label>Auto-Advance Turns</label><input type="checkbox" checked={settings.autoAdvance} onChange={e => update('autoAdvance', e.target.checked)} /></div>
        <div className="setting-row"><label>Enemy AI Aggression</label><select value={settings.enemyAI} onChange={e => update('enemyAI', e.target.value)}><option value="random">Random Target</option><option value="lowest_hp">Lowest HP</option><option value="highest_threat">Highest Threat</option></select></div>
        <div className="setting-row"><label>Friendly Fire</label><input type="checkbox" checked={settings.friendlyFire} onChange={e => update('friendlyFire', e.target.checked)} /></div>
        <div className="setting-row"><label>Death Saves</label><input type="checkbox" checked={settings.deathSaves} onChange={e => update('deathSaves', e.target.checked)} /></div>
        <div className="setting-row"><label>Overkill Damage</label><input type="checkbox" checked={settings.overkillCarry} onChange={e => update('overkillCarry', e.target.checked)} /></div>
        <div className="setting-row"><label>Critical Hit Multiplier</label><select value={settings.critMultiplier} onChange={e => update('critMultiplier', e.target.value)}><option value="2x">2x (Standard)</option><option value="3x">3x (Brutal)</option><option value="custom">Custom</option></select></div>
        <div className="setting-row"><label>Initiative Style</label><select value={settings.initiativeStyle} onChange={e => update('initiativeStyle', e.target.value)}><option value="standard">Standard (Individual)</option><option value="group">Group (Party vs Enemies)</option><option value="side">Side-Based (Alternating)</option></select></div>
        <div className="setting-row"><label>🗺️ Tactical Zones</label><input type="checkbox" checked={settings.zoneCombat} onChange={e => update('zoneCombat', e.target.checked)} /></div>
        <div className="setting-row"><label>🔄 Combat Sorting</label><input type="checkbox" checked={settings.combatSorting} onChange={e => update('combatSorting', e.target.checked)} /></div>
      </div>
      <div style={{ padding: '12px 16px' }}><button className="btn-primary" onClick={handleSave}>Save Changes</button></div>
    </div>
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚔️ Combat Settings</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <div className="setting-row">
            <label>Turn Timer</label>
            <select value={settings.turnTimer} onChange={e => update('turnTimer', e.target.value)}>
              <option value="30">30 seconds</option>
              <option value="60">60 seconds</option>
              <option value="90">90 seconds</option>
              <option value="unlimited">Unlimited</option>
            </select>
          </div>
          <div className="setting-row">
            <label>Auto-Advance Turns</label>
            <input type="checkbox" checked={settings.autoAdvance} onChange={e => update('autoAdvance', e.target.checked)} />
          </div>
          <div className="setting-row">
            <label>Enemy AI Aggression</label>
            <select value={settings.enemyAI} onChange={e => update('enemyAI', e.target.value)}>
              <option value="random">Random Target</option>
              <option value="lowest_hp">Lowest HP</option>
              <option value="highest_threat">Highest Threat</option>
            </select>
          </div>
          <div className="setting-row">
            <label>Friendly Fire</label>
            <input type="checkbox" checked={settings.friendlyFire} onChange={e => update('friendlyFire', e.target.checked)} />
          </div>
          <div className="setting-row">
            <label>Death Saves</label>
            <input type="checkbox" checked={settings.deathSaves} onChange={e => update('deathSaves', e.target.checked)} />
          </div>
          <div className="setting-row">
            <label>Overkill Damage (carry to next)</label>
            <input type="checkbox" checked={settings.overkillCarry} onChange={e => update('overkillCarry', e.target.checked)} />
          </div>
          <div className="setting-row">
            <label>Critical Hit Multiplier</label>
            <select value={settings.critMultiplier} onChange={e => update('critMultiplier', e.target.value)}>
              <option value="2x">2x (Standard)</option>
              <option value="3x">3x (Brutal)</option>
              <option value="custom">Custom</option>
            </select>
          </div>
          <div className="setting-row">
            <label>Initiative Style</label>
            <select value={settings.initiativeStyle} onChange={e => update('initiativeStyle', e.target.value)}>
              <option value="standard">Standard (Individual)</option>
              <option value="group">Group (Party vs Enemies)</option>
              <option value="side">Side-Based (Alternating)</option>
            </select>
          </div>
          <div className="setting-row">
            <label>🗺️ Tactical Zones</label>
            <input type="checkbox" checked={settings.zoneCombat} onChange={e => update('zoneCombat', e.target.checked)} />
          </div>
          <div className="setting-row">
            <label>🔄 Combat Sorting</label>
            <input type="checkbox" checked={settings.combatSorting} onChange={e => update('combatSorting', e.target.checked)} />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-primary" onClick={handleSave}>Save Changes</button>
        </div>
      </div>
    </div>
  );
}
